export default __webpack_public_path__ + "e57c7676caeba5f02444b56887130f17.svg";